import dayjs from 'dayjs';

export const DATE_FORMAT_API = 'MM/DD/YYYY';

export const formatMonthPostingDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '';

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (!start.isValid() || !end.isValid()) return '';

  return `${start.format(DATE_FORMAT_API)} - ${end.format(DATE_FORMAT_API)}`;
};

export const getProductCategoryDisplayName = (productCategory) =>
  (
    productCategory?.x3_productname ??
    productCategory?.x3ProductName ??
    productCategory?.code ??
    productCategory?.name ??
    String(productCategory?.id ?? '')
  )
    .toString()
    .trim();

const getProductCategoryPostedRange = (productCategory) =>
  formatMonthPostingDateRange(
    productCategory?.start_date ?? productCategory?.startDate,
    productCategory?.end_date ?? productCategory?.endDate,
  );

export const buildProductTypeSelectData = (productCategories) => {
  const list = Array.isArray(productCategories) ? productCategories : [];
  const seenX3Names = new Set();
  const productNamesById = {};
  const productOptions = [];

  list.forEach((productCategory) => {
    if (productCategory?.status === 'Inactive') return;

    const displayName = getProductCategoryDisplayName(productCategory);
    const x3Key = displayName.toUpperCase();

    if (!displayName || seenX3Names.has(x3Key)) return;

    seenX3Names.add(x3Key);
    productNamesById[String(productCategory.id)] = displayName;

    productOptions.push({
      value: String(productCategory.id),
      text: displayName,
      label: displayName,
      displayName,
      dateRange: getProductCategoryPostedRange(productCategory) || '',
    });
  });

  productOptions.sort((a, b) => a.displayName.localeCompare(b.displayName, 'en', { sensitivity: 'base' }));

  const options = [
    { value: '', text: 'Select X3 Product Name', label: 'Select X3 Product Name', disabled: true },
    ...productOptions,
  ];

  return { options, productNamesById };
};
